const questions = {
  A7K9L2M3QX: {
    question: "Wie viele Mischer wurden letztes Jahr in Freudenberg produziert?",
    options: ["46 Neumaschinen", "58 Neumaschinen", "71 Neumaschinen", "87 Neumaschinen"],
    correctAnswer: 2,
    letter: 'G',
  },
  Z3N5B8Y1TP: {
    question: "Was ist die neuste Maschine in unserem Maschinenpark?",
    options: ["SHW", "Union", "WFL", "Pama"],
    correctAnswer: 0,
    letter: "N",
  },
  R6D4W2E9HJ: {
    question: "Was hat das Lager noch für weitere Aufgaben, außer “zu lagern“?",
    options: ["Ausgeben von Werkzeugen", "Versand von Serviceprodukten", "Instandhaltung von Gabelstaplern", "Verträge mit Lieferanten verhandeln"],
    correctAnswer: 1,
    letter: "X",
  },
  M1Q7X5L8VA: {
    question: "Wie komme ich an Werkzeuge?",
    options: ["Im Lager", "Ich frage meinen Vorgesetzen", "In der Werkzeugausgabe fragen ", "Ich kann freiliegende Werkzeuge einfach benutzen"],
    correctAnswer: 2,
    letter: "T",
  },
  C9H3N2K5UB: {
    question: "Wofür steht HR ausgeschrieben?",
    options: ["Human Relations", "Human Resources", "Human Recruiting", "Human Resource Management"],
    correctAnswer: 1,
    letter: "E",
  },
  T4V8G6R1SD: {
    question: "Wie viel Rabatt bekommen Auszubildende extra auf ihr Mittagessen?",
    options: ["Nichts", "1€", "2€", "10%"],
    correctAnswer: 2,
    letter: "H",
  },
  W7M1P4E6JQ: {
    question: "Was ist das Technikum?",
    options: ["Praktische Vorführung unserer Maschinen für unsere Kunden", "Technikmuseum für die Ausstellung von alten Produkten", "Testumgebung unter produktionsnahmen Bedingungen von Neuentwicklungen", "Herstellung von Bauteilen für die eigenen Maschinen"],
    correctAnswer: [0,2],
    letter: "F",
  },
  K5F2R9D7LU: {
    question: "Wie viele Auszubildenden haben wir in Freudenberg?",
    options: ["20", "23", "28", "35"],
    correctAnswer: 2,
    letter: "E",
  },
  H8X3C1V5ZN: {
    question: "Wie viele Azubis gibt es im 1. Lehrjahr?",
    options: ["9", "10", "11", "12"],
    correctAnswer: 1,
    letter: "N",
  },
};

export default questions;
